import { memo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { handleModal, handleModalData } from "../../redux/actions/modals";
import { getAppInfoData, handleKeyDownOnDiv } from '../../utils/global_functions';
import { APP_INFO_PARAMS, HAMBURGER_LIST, LINK_OPEN_MODES } from '../../utils/global_variables';

const Footer = (props) => {

  const dispatch = useDispatch();
  const objAppInfo = useSelector(state => state.appInfo.appInfo);
  const aboutUsUrl = getAppInfoData(APP_INFO_PARAMS.APP_ABOUTUS_URL, objAppInfo);
  const disclaimerUrl = getAppInfoData(APP_INFO_PARAMS.APP_DISCLAIMER_MODE, objAppInfo);



  // const handleTermsAndCondition = () => {
  //   dispatch(handleModal([{ "TERMS_CONDITION_MODAL": true }]));
  // };

  const handleAboutUs = () => {
    if(aboutUsUrl){
     window.open(aboutUsUrl);
    }else{
      dispatch(handleModal([{ "ABOUT_US_MODAL": true }]));
    }
  };


  const handleDisclaimer = () => {
    if(disclaimerUrl?.openmode === LINK_OPEN_MODES.REDIRECT){
      window.open(disclaimerUrl?.url);
    }else{
      dispatch(handleModal([{ "DISCLAIMER_MODAL": true }]));
    }
  };

  const handleExchangeTiming = () => {
    dispatch(handleModal([{ "EXCHANGE_TIMING_MODAL": true }]));
  };

  const handleMembershipDetails = () => {
    dispatch(handleModal([{ "MEMBERSHIP_DETAILS_MODAL": true }]));
  };


  const handleExchangeLinks = ()=>{
    dispatch(handleModal([{ 'SSO_LINK_MODAL': true }]));
    dispatch(handleModalData({ header: "Links", data:  [], name: HAMBURGER_LIST.EXCHANGE_LINKS, id: 306 }));
  }

  return (
    <div className={props.className}>
      <Container fluid className='p-0'>
        <Row className='g-0'>
          <Col className='d-flex justify-content-start align-items-start'>
            <a className='font-medium font-size1 focus' href='#' onKeyDown={handleKeyDownOnDiv} onClick={handleExchangeTiming}>Exchange Timings</a>
            <span className='font-regular font-size1 color-textual-link px-2'>|</span>
            <a className='font-medium font-size1 focus' href='#' onKeyDown={handleKeyDownOnDiv} onClick={handleAboutUs}>About Us</a>
            <span className='font-regular font-size1 color-textual-link px-2'>|</span>
            <a className='font-medium font-size1 focus' href='#' onClick={() => handleMembershipDetails()}>Membership Details</a>
            <span className='font-regular font-size1 color-textual-link px-2'>|</span>
            <a className='font-medium font-size1 focus' href='#' onClick={handleExchangeLinks}>Links</a>
            <span className='font-regular font-size1 color-textual-link px-2'>|</span>
            <a className='font-medium font-size1 focus' href='#' onKeyDown={handleKeyDownOnDiv} onClick={handleDisclaimer}>Disclaimer</a>
          </Col>
        </Row>
        <Row className='g-0 my-2'>
          <Col className='font-regular font-size1 color-subtext'>
            Breeze v2.0.0.0 Powered by Synapsewave Innovations Pvt. Ltd.
          </Col>
        </Row>
      </Container>
    </div>

  );
};
export default memo(Footer);